import { getYear } from 'date-fns';
import _ from 'lodash';
import { compareCaseInsensitive } from 'shared/utils';

export const receiveStatus = (
  productOrder,
  shipment,
  shipmentAllItems,
  combinedData,
  bills,
  billsItems,
  inboundShipment
) => {
  if (inboundShipment) {
   return inboundShipment.status;
  }

  if (productOrder.closed === 1) {
    return 'received';
  }

  const year = getYear(new Date(shipment.landingDate));
  if (year <= 2021) {
    return 'received';
  }

  // // TODO: change to read from Inbound
  // const bill = _.find(bills, { PurchaseOrderId: productItem.shipmentId });
  // if (typeof bill === 'undefined') {
  //   return 'open';
  // }

  // let received = true;
  // shipmentAllItems
  //   .filter(r => r.shipmentId === productItem.id)
  //   .map(r => {
  //     const temp = _.find(billsItems, (billItem) => {
  //       return billItem.purchase_order_id === productItem.shipmentId &&
  //         compareCaseInsensitive(billItem.ItemLineItemRefFullName, r.sku)
  //     });

  //     if(temp) {
  //       if(temp.ItemLineQuantity < r.expected) {
  //         received = false
  //       }
  //     }
  //   });

  //   if(received) {
  //     return 'received';
  //   } else {
  //     return 'partially received';
  //   }
};

export const productOrderStatus = productOrder => {
  if (productOrder === undefined) {
    return '';
  }
  return productOrder.closed === 1 ? 'Closed' : 'Open';
};

export const getECSD = (shipmentAllItems, shipment) => {
  let notWaitlist = false;

  shipmentAllItems
    .filter(r => r.shipmentId === shipment.id)
    .map(r => {
      if (r.waitlist === 0) {
        notWaitlist = true;
      }
    });

  return {
    waitlist: !notWaitlist
  };
};
